import React, { useContext, useRef } from "react";
import Swal from "sweetalert2";

import AuthService from "../../../../services/Admin/AuthService";
import CompanyService from "../../../../services/Admin/CompanyService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";

const FlashMessage = (props) => {
  const data = props.data;
  const loadingCtx = useContext(LoadingContext);

  const flashMessageRef = useRef();
  const utiFlashMessageRef = useRef();

  const updateHandler = async () => {
    const flashMessage = flashMessageRef.current.value;
    const utiFlashMessage = utiFlashMessageRef.current.value;

    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await CompanyService.updateFlashMessage(
        token,
        flashMessage,
        utiFlashMessage
      );

      if (responseData.status === "SUCCESS") {
        Swal.fire("Success!", responseData.message, "success");
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire("Oops!", HttpError.getError(error), "error");
    }

    loadingCtx.stopLoading();
  };

  return (
    <div className="row">
      <div className="col-md-8 mx-auto">
        {/* Flash Message */}
        <div className="form-group row">
          <label className="col-sm-3 col-form-label">Flash Message</label>
          <div className="col-sm-9">
            <textarea
              className="form-control"
              rows="4"
              ref={flashMessageRef}
              defaultValue={data?.flash_message || ""}
              placeholder="Supports HTML content"
            />
          </div>
        </div>

        {/* UTI Flash Message */}
        <div className="form-group row">
          <label className="col-sm-3 col-form-label">UTI Flash Message</label>
          <div className="col-sm-9">
            <textarea
              className="form-control"
              rows="4"
              ref={utiFlashMessageRef}
              defaultValue={data?.uti_flash_message || ""}
              placeholder="Supports HTML content"
            />
            <small className="text-muted">
              HTML allowed (e.g. &lt;b&gt;, &lt;span&gt;, &lt;br&gt;)
            </small>
          </div>
        </div>

        <div className="text-center">
          <button
            type="button"
            className="btn btn-primary"
            onClick={updateHandler}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default FlashMessage;
